import React, { useEffect, useState} from "react";
const getTankColor = (level) => {
    if (level > 70) return "#99cc33";     // Green
    if (level > 40) return "#FFC107";     // Orange
    if (level > 20) return "#FFEB3B";     // Yellow
    return "#F44336";                     // Red
};


export const TankLevel = ({ tankLevel }) => {
    return (
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <div
                style={{
                    width: "40px",
                    height: "18px",
                    border: "2px solid #999",
                    borderRadius: "4px",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        height: "100%",
                        width: `${tankLevel}%`,
                        backgroundColor: getTankColor(tankLevel),
                        borderRadius: "3px",
                        transition: "0.3s ease",
                    }}
                ></div>
            </div>

            <span style={{ fontSize: "14px" }}>{tankLevel}%</span>
        </div>
    );
};

